import { ICreateSettlementFeeForm } from '../../../../../types/order/fees/ICreateSettlementItemForm';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';

export const calculateMultiFeeTotal = (
  fees: ICreateSettlementFeeForm[],
  feePropertyName: string,
  statementSettlementPropertyValues: { [key: string]: any },
  dirty: boolean
): number => {
  return dirty
    ? fees.reduce((sum, fee) => sum + (fee.numericFeePropertyValues[feePropertyName] || 0), 0)
    : statementSettlementPropertyValues[feePropertyName];
};

export const calculateSingleFeeTotal = (
  fee: ICreateSettlementFeeForm,
  statementSettlementPropertyValues: { [key: string]: any },
  dirty: boolean
): number => {
  return dirty
    ? (fee.numericFeePropertyValues[eFeePropertyNames.BuyerPaidAtClosing] || 0) +
        (fee.numericFeePropertyValues[eFeePropertyNames.BuyerPaidBeforeClosing] || 0) +
        (fee.numericFeePropertyValues[eFeePropertyNames.SellerPaidAtClosing] || 0) +
        (fee.numericFeePropertyValues[eFeePropertyNames.SellerPaidBeforeClosing] || 0) +
        (fee.numericFeePropertyValues[eFeePropertyNames.OthersPaid] || 0) +
        (fee.numericFeePropertyValues[eFeePropertyNames.OthersPaidBuyer] || 0) +
        (fee.numericFeePropertyValues[eFeePropertyNames.OthersPaidSeller] || 0)
    : (statementSettlementPropertyValues[eFeePropertyNames.BuyerPaidAtClosing] || 0) +
        (statementSettlementPropertyValues[eFeePropertyNames.BuyerPaidBeforeClosing] || 0) +
        (statementSettlementPropertyValues[eFeePropertyNames.SellerPaidAtClosing] || 0) +
        (statementSettlementPropertyValues[eFeePropertyNames.SellerPaidBeforeClosing] || 0) +
        (statementSettlementPropertyValues[eFeePropertyNames.OthersPaid] || 0) +
        (statementSettlementPropertyValues[eFeePropertyNames.OthersPaidBuyer] || 0) +
        (statementSettlementPropertyValues[eFeePropertyNames.OthersPaidSeller] || 0);
};
